export const TBL_HEADERS = [
  {
    name: "",
    variable: "",
  },
  {
    name: "User Name",
    variable: "userName",
  },
  {
    name: "Activity Status",
    variable: "password",
  },
  {
    name: "Activity Name",
    variable: "clientSecretKey",
  },
  {
    name: "Activity Date",
    variable: "accountNumber",
  },
  {
    name: "Activity Time",
    variable: "clientId",
  },
];
